import React from 'react';
import { VerificationForm } from '@sheerid/jslib';
import '@sheerid/jslib/sheerid.css';
import './App.css';
import { programId } from './programOptions';

const App = () => {
    window.parent.postMessage(
        JSON.stringify({
            action: 'updateHeight',
            height: 650,
        }),
        '*',
    );

    return (
        <div className="sid-page">
            <header className="sid-header">
                <img className="sid-header__logo" src="logo.png" alt="Dockers" />
            </header>
            <div className="page__columns">
                <div className="page__form page__column">
                    <VerificationForm programId={programId} />
                </div>
            </div>
        </div>
    );
};

export default App;
